import { tv } from 'tailwind-variants';
import type { VariantProps } from 'tailwind-variants';

type Props = VariantProps<typeof className>;
export function HorizontalRule(props: Props) {
	return <hr class={className(props)} />;
}

const className = tv({
	variants: {
		direction: {
			top: 'wavy-t',
			bottom: 'wavy-b',
			none: 'border-b border-zinc-200 dark:border-zinc-700',
		},
	},
	compoundVariants: [
		{
			direction: ['bottom', 'top'],
			class: 'h-1.75 border-none bg-zinc-200 dark:bg-zinc-700',
		},
	],
	defaultVariants: {
		direction: 'top',
	},
});
